module.exports = __webpack_public_path__ + "media/flags/uz-562cdaf4.svg";